import { render, staticRenderFns } from "./NoteContent.vue?vue&type=template&id=53d59a20&scoped=true&"
import script from "./NoteContent.vue?vue&type=script&lang=js&"
export * from "./NoteContent.vue?vue&type=script&lang=js&"
import style0 from "./NoteContent.vue?vue&type=style&index=0&id=53d59a20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d59a20",
  null
  
)

export default component.exports